import React from 'react';
export function CTAButton() {
  return <a href="https://maleup.de/products/quiz-deal-3x-anti-aging-face-cream?variant=52835646537995" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center px-6 py-3.5 bg-[#1A1A1A] hover:bg-[#333333] transition-colors cursor-pointer w-full" style={{
    maxWidth: 602,
    minHeight: 57,
    fontFamily: 'Figtree, sans-serif'
  }} aria-label="Jetzt MaleUp mit 60€ Rabatt sichern" data-id="element-184">
      <span className="text-white font-bold text-base tracking-wide text-center" data-id="element-185">
        JETZT MALEUP MIT 60€ RABATT SICHERN →
      </span>
    </a>;
}